<div class="description">
  <div trans>Add an animation to draw attention to this link.</div>
  <div trans>Selected animation will repeat five times by default.</div>
</div>
<div class="animation-list">
  <button
    type="button"
    mat-stroked-button
    [class.selected]="!(selectedAnimation$ | async)"
    (click)="selectAnimation(null)"
    trans
  >
    None
  </button>
  <button
    type="button"
    mat-stroked-button
    class="animate__animated"
    [class.selected]="(selectedAnimation$ | async) === animation"
    *ngFor="let animation of animationList"
    (mouseenter)="onMouseEnter($event, animation)"
    (mouseleave)="onMouseLeave($event, animation)"
    (click)="selectAnimation(animation)"
    trans
  >
    {{ animation }}
  </button>
</div>
